import { Navigate, Outlet } from "react-router";
import { CUSTOM_THEME, useFoodpilotContext } from "src/context/FoodpilotContext";
import type { Slugs } from "src/context/ProtectedContext";

type CustomThemeProtectionProps = {
    action: Slugs;
};

export const CustomThemeProtection = (props: CustomThemeProtectionProps) => {
    const { action } = props;
    const { canUser } = useFoodpilotContext();

    if (!canUser(action, CUSTOM_THEME)) {
        return <Navigate to="/settings" replace />;
    }

    return <Outlet />;
};
